import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { TransportType } from '../transport-type';
import { TravelType } from '../travel-type';

@Component({
  selector: 'app-travel-edit',
  templateUrl: './travel-edit.component.html',
  styleUrls: ['./travel-edit.component.css']
})
export class TravelEditComponent implements OnInit {

  travelType: TravelType | null = null;
  travelTypeForm: FormGroup | null = null;
  types: TransportType[] = [];

  constructor(
    private httpService: HttpService,
    private route: ActivatedRoute,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
    let travelId = Number(this.route.snapshot.paramMap.get("travelId"));

    this.httpService.getTransportTypes().subscribe(types => {
      this.types = types;
      this.httpService.getTravelType(travelId).subscribe(res => {
        this.travelType = res;
        this.travelTypeForm = this.builder.group({
          code: this.travelType.code,
          type: this.travelType.transportType,
          description: this.travelType.description,
          billingNote: this.travelType.billingNote,
          comment: this.travelType.comment
        });
      });
    });
  }

  updateTravelType(){
    let travelType = this.travelType!;
    let travelTypeFormValue = this.travelTypeForm!.value;
    travelType.code = travelTypeFormValue.code;
    travelType.transportType = travelTypeFormValue.type;
    travelType.description = travelTypeFormValue.description;
    travelType.billingNote = travelTypeFormValue.billingNote;
    travelType.comment = travelTypeFormValue.comment;
    this.httpService.putTravelType(travelType).subscribe(() => {
      console.log("success");
    });
  }

}
